import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';
import Vue from 'vue';
import Vuex from 'vuex';
import appVersion from './modules/appVersion';
import auth from './modules/auth';
import car from './modules/car';
import contactPerson from './modules/contactPerson';
import country from './modules/country';
import county from './modules/county';
import currency from './modules/currency';
import customerCategory from './modules/customerCategory';
import customerGroup from './modules/customerGroup';
import customerOrder from './modules/customerOrder';
import customerPriceList from './modules/customerPriceList';
import customerReturnOrder from './modules/customerReturnOrder';
import customerSale from './modules/customerSale';
import customRepresentativePriceList from './modules/customRepresentativePriceList';
import customsTariffNumber from './modules/customsTariffNumber';
import declutter from './modules/declutter';
import declutterMeasure from './modules/declutterMeasure';
import declutterReport from './modules/declutterReport';
import deliveryReceiptReceives from './modules/deliveryReceiptReceives';
import docket from './modules/docket';
import docketBook from './modules/docketBook';
import documentType from './modules/documentType';
import docVersion from './modules/docVersion';
import glaNumber from './modules/glaNumber';
import imports from './modules/imports';
import invoice from './modules/invoice';
import invoiceBook from './modules/invoiceBook';
import invoiceReceiptReceives from './modules/invoiceReceiptReceives';
import inwardHandling from './modules/inwardHandling';
import job from './modules/job';
import location from './modules/location';
import manufacturer from './modules/manufacturer';
import ntaxPartner from './modules/ntaxPartner';
import outstanding from './modules/outstanding';
import ownCompany from './modules/ownCompany';
import packing from './modules/packing';
import packType from './modules/packType';
import pareto from './modules/pareto';
import partner from './modules/partner';
import partnerPrice from './modules/partnerPrice';
import paymentMethod from './modules/paymentMethod';
import priceType from './modules/priceType';
import product from './modules/product';
import productCategory from './modules/productCategory';
import productConsumption from './modules/productConsumption';
import productHistory from './modules/productHistory';
import proformCustomerOrder from './modules/proformCustomerOrder';
import receiptSetting from './modules/receiptSetting';
import receiptTransfer from './modules/receiptTransfer';
import representativeDelivery from './modules/representativeDelivery';
import representativeDrop from './modules/representativeDrop';
import representativeForm from './modules/representativeForm';
import representativeOrder from './modules/representativeOrder';
import representativePayment from './modules/representativePayment';
import representativePlacement from './modules/representativePlacement';
import representativePrice from './modules/representativePrice';
import representativeReplacement from './modules/representativeReplacement';
import representativeSale from './modules/representativeSale';
import representativeTransfer from './modules/representativeTransfer';
import representativeTransferRequest from './modules/representativeTransferRequest';
import role from './modules/role';
import service from './modules/service';
import serviceCategory from './modules/serviceCategory';
import shop from './modules/shop';
import shopCategory from './modules/shopCategory';
import shopChain from './modules/shopChain';
import shopPrice from './modules/shopPrice';
import sidebar from './modules/sidebar';
import simpleStockValue from './modules/simpleStockValue';
import stockTaking from './modules/stockTaking';
import stockTakingReport from './modules/stockTakingReport';
import stockTakingTool from './modules/stockTakingTool';
import stockTransformation from './modules/stockTransformation';
import stockValue from './modules/stockValue';
import storage from './modules/storage';
import storageStockReport from './modules/storageStockReport';
import stowage from './modules/stowage';
import supplierCategory from './modules/supplierCategory';
import supplierOrder from './modules/supplierOrder';
import supplierReturnOrder from './modules/supplierReturnOrder';
import task from './modules/task';
import todo from './modules/todo';
import todoRecurringPattern from './modules/todoRecurringPattern';
import tourCalendar from './modules/tourCalendar';
import user from './modules/user';
import userCategory from './modules/userCategory';
import vat from './modules/vat';
import stockMovement from './modules/stockMovement';
import worktimeReport from './modules/worktimeReport';

const logrocketPlugin = createPlugin(LogRocket);

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [logrocketPlugin],
  modules: {
    auth: {
      namespaced: true,
      ...auth,
    },
    user: {
      namespaced: true,
      ...user,
    },
    role: {
      namespaced: true,
      ...role,
    },
    vat: {
      namespaced: true,
      ...vat,
    },
    country: {
      namespaced: true,
      ...country,
    },
    county: {
      namespaced: true,
      ...county,
    },
    glaNumber: {
      namespaced: true,
      ...glaNumber,
    },
    currency: {
      namespaced: true,
      ...currency,
    },
    customsTariffNumber: {
      namespaced: true,
      ...customsTariffNumber,
    },
    car: {
      namespaced: true,
      ...car,
    },
    packType: {
      namespaced: true,
      ...packType,
    },
    productCategory: {
      namespaced: true,
      ...productCategory,
    },
    userCategory: {
      namespaced: true,
      ...userCategory,
    },
    supplierCategory: {
      namespaced: true,
      ...supplierCategory,
    },
    partner: {
      namespaced: true,
      ...partner,
    },
    todo: {
      namespaced: true,
      ...todo,
    },
    task: {
      namespaced: true,
      ...task,
    },
    contactPerson: {
      namespaced: true,
      ...contactPerson,
    },
    location: {
      namespaced: true,
      ...location,
    },
    shopCategory: {
      namespaced: true,
      ...shopCategory,
    },
    shop: {
      namespaced: true,
      ...shop,
    },
    shopChain: {
      namespaced: true,
      ...shopChain,
    },
    manufacturer: {
      namespaced: true,
      ...manufacturer,
    },
    serviceCategory: {
      namespaced: true,
      ...serviceCategory,
    },
    service: {
      namespaced: true,
      ...service,
    },
    product: {
      namespaced: true,
      ...product,
    },
    sidebar: {
      namespaced: true,
      ...sidebar,
    },
    ownCompany: {
      namespaced: true,
      ...ownCompany,
    },
    todoRecurringPattern: {
      namespaced: true,
      ...todoRecurringPattern,
    },
    customerGroup: {
      namespaced: true,
      ...customerGroup,
    },
    storage: {
      namespaced: true,
      ...storage,
    },
    priceType: {
      namespaced: true,
      ...priceType,
    },
    supplierOrder: {
      namespaced: true,
      ...supplierOrder,
    },
    supplierReturnOrder: {
      namespaced: true,
      ...supplierReturnOrder,
    },
    inwardHandling: {
      namespaced: true,
      ...inwardHandling,
    },
    representativeOrder: {
      namespaced: true,
      ...representativeOrder,
    },
    invoiceBook: {
      namespaced: true,
      ...invoiceBook,
    },
    receiptSetting: {
      namespaced: true,
      ...receiptSetting,
    },
    customerOrder: {
      namespaced: true,
      ...customerOrder,
    },
    packing: {
      namespaced: true,
      ...packing,
    },
    stowage: {
      namespaced: true,
      ...stowage,
    },
    customerReturnOrder: {
      namespaced: true,
      ...customerReturnOrder,
    },
    declutter: {
      namespaced: true,
      ...declutter,
    },
    declutterMeasure: {
      namespaced: true,
      ...declutterMeasure
    },
    customerSale: {
      namespaced: true,
      ...customerSale,
    },
    invoice: {
      namespaced: true,
      ...invoice,
    },
    representativeDrop: {
      namespaced: true,
      ...representativeDrop
    },
    ntaxPartner: {
      namespaced: true,
      ...ntaxPartner
    },
    documentType: {
      namespaced: true,
      ...documentType
    },
    docketBook: {
      namespaced: true,
      ...docketBook
    },
    docket: {
      namespaced: true,
      ...docket,
    },
    stockTaking: {
      namespaced: true,
      ...stockTaking
    },
    stockTakingReport: {
      namespaced: true,
      ...stockTakingReport
    },
    representativePrice: {
      namespaced: true,
      ...representativePrice
    },
    job: {
      namespaced: true,
      ...job
    },
    tourCalendar: {
      namespaced: true,
      ...tourCalendar,
    },
    paymentMethod: {
      namespaced: true,
      ...paymentMethod
    },
    stockTakingTool: {
      namespaced: true,
      ...stockTakingTool,
    },
    proformCustomerOrder: {
      namespaced: true,
      ...proformCustomerOrder
    },
    representativePlacement: {
      namespaced: true,
      ...representativePlacement,
    },
    appVersion: {
      namespaced: true,
      ...appVersion
    },
    docVersion: {
      namespaced: true,
      ...docVersion
    },
    representativeForm: {
      namespaced: true,
      ...representativeForm
    },
    outstanding: {
      namespaced: true,
      ...outstanding
    },
    representativeSale: {
      namespaced: true,
      ...representativeSale
    },
    partnerPrice: {
      namespaced: true,
      ...partnerPrice
    },
    shopPrice: {
      namespaced: true,
      ...shopPrice
    },
    pareto: {
      namespaced: true,
      ...pareto
    },
    productHistory: {
      namespaced: true,
      ...productHistory
    },
    stockValue: {
      namespaced: true,
      ...stockValue
    },
    simpleStockValue: {
      namespaced: true,
      ...simpleStockValue
    },
    productConsumption: {
      namespaced: true,
      ...productConsumption
    },
    customerPriceList: {
      namespaced: true,
      ...customerPriceList
    },
    customerCategory: {
      namespaced: true,
      ...customerCategory
    },
    customRepresentativePriceList: {
      namespaced: true,
      ...customRepresentativePriceList
    },
    representativePayment: {
      namespaced: true,
      ...representativePayment
    },
    storageStockReport: {
      namespaced: true,
      ...storageStockReport
    },
    stockTransformation: {
      namespaced: true,
      ...stockTransformation
    },
    stockMovement: {
      namespaced: true,
      ...stockMovement
    },
    worktimeReport: {
      namespaced: true,
      ...worktimeReport
    },
    invoiceReceiptReceives: {
      namespaced: true,
      ...invoiceReceiptReceives
    },
    deliveryReceiptReceives: {
      namespaced: true,
      ...deliveryReceiptReceives
    },
    representativeDelivery: {
      namespaced: true,
      ...representativeDelivery
    },
    representativeReplacement: {
      namespaced: true,
      ...representativeReplacement
    },
    representativeTransfer: {
      namespaced: true,
      ...representativeTransfer
    },
    representativeTransferRequest: {
      namespaced: true,
      ...representativeTransferRequest
    },
    receiptTransfer: {
      namespaced: true,
      ...receiptTransfer
    },
    declutterReport: {
      namespaced: true,
      ...declutterReport
    },
    imports: {
      namespaced: true,
      ...imports,
    },
  }
});
